import { ReactElement, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { Toast } from "primereact/toast";
import { Image } from 'primereact/image';
import successImage from '../../../../assets/images/check-circle.svg';
import { HttpService } from "../../../../services/HttpService";

type PropTypes = {

    isPaymentEnabled: boolean;
    companyId: number;
    documentId: string | null;
}

function Completed(props: PropTypes): ReactElement {
    const { isPaymentEnabled, companyId, documentId } = props;

    const toast = useRef<Toast>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isPaymentEnabled) {
            HttpService.post(
                `/api/companies/${companyId}/file83b/${documentId}/compleat`,
                {
                    companyId,
                    documentId
                }
            ).then(() => {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Submission confirmed!',
                });
            }).catch(() => {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'There was an issue completing your submission.',
                })
            })
        } else {
            toast.current?.show({
                severity: 'success',
                summary: 'Success',
                detail: 'Submission confirmed!',
            })
        }

    }, [isPaymentEnabled, companyId, documentId]);


    const handleRedirect = () => {
        navigate('/admin-dashboard');
    };

    return (
        <div className="w-full flex flex-column align-items-center justify-content-center h-full">
            <Toast ref={toast} onHide={handleRedirect} />
            <div className="flex flex-column align-content-center gap-2 text-center w-full">
                <Image src={successImage} alt="Success" className="w-4rem h-auto align-self-center" imageClassName="max-w-full"/>
                <h2>Submission confirmed</h2>
                <p>Your submission has been successfully confirmed.</p>
                <p>You’ll be redirected in a moment.</p>
            </div>
        </div>
    );
}

export default Completed;